import { Route as SupplierProfitabilityRoute } from "@/routes/(pharma)/_layout/reports/supplier-profitability/index";
import { useQuery } from "@tanstack/react-query";
import { getSupplierProfitability } from "../-data/api";

interface ReportQueryResult {
  items: any[];
  totalCount: number;
  page: number;
  pageSize: number;
}

export const useSupplierProfitabilityData = () => {
  const searchParams = SupplierProfitabilityRoute.useSearch();
  
  return useQuery<ReportQueryResult>({
    queryKey: ["supplier-profitability", searchParams],
    queryFn: async () => {
      const response = await getSupplierProfitability(searchParams.page || 1, searchParams.pageSize || 10);
      return {
        items: response.supplierProfitabilityItems,
        totalCount: response.totalCount,
        page: searchParams.page || 1,
        pageSize: searchParams.pageSize || 10,
      };
    },
    placeholderData: (previousData) => previousData,
    refetchOnWindowFocus: false,
    staleTime: 5 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
  });
};